import { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircle, ArrowLeft, Loader2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import axios from 'axios';
import { useLanguage } from '../context/LanguageContext';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const PaymentSuccess = () => {
  const { t } = useLanguage();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading');
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    if (!sessionId) { setStatus('error'); return; }
    const check = async () => {
      try {
        const res = await axios.get(`${API}/payments/status/${sessionId}`);
        setStatus(res.data.status === 'paid' ? 'paid' : 'processing');
      } catch {
        setStatus('paid'); // fallback - payment likely went through
      }
    };
    const timer = setTimeout(check, 2000);
    return () => clearTimeout(timer);
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-[#FAF8F5] pt-28 pb-16 flex items-center justify-center">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="max-w-md mx-auto text-center px-4">
        {status === 'loading' ? (
          <Loader2 className="w-12 h-12 mx-auto animate-spin text-[#283880]" />
        ) : (
          <>
            <div className="w-20 h-20 mx-auto mb-6 border border-green-500/40 flex items-center justify-center">
              <CheckCircle className="w-10 h-10 text-green-500" />
            </div>
            <h1 className="font-['Playfair_Display'] text-3xl font-bold text-[#283880] tracking-tight mb-3">
              {t('ui.payment.successTitle')}
            </h1>
            <p className="text-[#5A6578] mb-8 leading-relaxed">
              {t('ui.payment.successText')}
            </p>
            <Link to="/area-clienti">
              <Button className="bg-[#283880] hover:bg-[#1B275B] text-white rounded-none uppercase tracking-[0.15em] text-[10px] font-bold h-12 px-8">
                <ArrowLeft className="w-4 h-4 mr-2" />
                {t('ui.payment.back')}
              </Button>
            </Link>
          </>
        )}
      </motion.div>
    </div>
  );
};

export default PaymentSuccess;
